export default "__VITE_ASSET__f8bdbd71__"